var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwimwearMen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.971 20.36l-3.157-11.2V6.745A.746.746 0 0023.068 6l-18.149.001a.746.746 0 00-.745.746v2.499L1.028 20.359a.744.744 0 00.606.94l9.648 1.461a.746.746 0 00.764-.376l1.961-3.544 1.953 3.516c.15.271.456.42.761.375l9.642-1.431a.747.747 0 00.609-.94zm-10.766-6.425a.746.746 0 01-.746-.746c0-2.49-1.12-2.986-1.46-3.078-.34.093-1.459.59-1.459 3.078a.746.746 0 01-1.491 0c0-3.64 1.997-4.395 2.686-4.547a.74.74 0 01.209-.035c.008-.002.015-.002.02-.002.01-.001.02.002.03.002l.042-.002.025.003a.72.72 0 01.156.025c.64.128 2.732.829 2.732 4.557a.743.743 0 01-.744.745zm6.118-5.331H5.665V7.493h16.657l.001 1.11z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgSwimwearMen;